export interface AppliedMaterial {
  materialName: string;
  [key: string]: unknown;
}

export interface AppliedMaterials {
  [key: string]: AppliedMaterial;
}

export interface VisualizerMessageData {
  screenshotImg?: string;
  appliedMaterials?: AppliedMaterials;
}

export interface UseVisualizerMessageParams {
  selectedColorName: string | undefined;
  colorVizName: string;
  onColorChange: (screenshotImg: string, colorName: string) => void;
  onClose: () => void;
}

export interface UseVisualizerMessageReturn {
  requestScreenshot: () => void;
}

// Constants
export const VISUALIZER_IFRAME_ID = 'visualizer-iframe';
export const SLABCLOUD_ORIGIN = 'https://slabcloud.com';
export const COUNTERTOP_MATERIAL_INDEX = 2;
